<template>
  <aside class="project-one-right-rail" qaid="project-one-right-rail">
    <project-one-right-rail-header
      :base-properties="baseProperties"
      :group-id="groupId"
      :is-back-button-enabled="true"
      @on-backpress="returnToPreviousRailView"
    />

    <section class="project-one-right-rail__body" qaid="project-one-right-rail-body">
      <project-one-customize-choice
        v-for="choice in rearrangedList"
        :key="choice.id"
        :base-properties="baseProperties"
        :choice="choice"
        :action-function="!isSingleLevelList ? displayListItem : selectChoice"
        :next-presentation-type="!isSingleLevelList ? 'CMP_LIST_ITEM' : null"
        :parent-group-id="groupId"
        :choice-id="choice.id"
        :is-selected="isSelected(choice.id)"
      />
    </section>

    <project-one-right-rail-footer
      v-if="isSingleLevelList"
      :base-properties="baseProperties"
      :button-action="confirmSelection"
      button-icon="check"
      :button-icon-left="true"
      :button-primary="true"
      :button-text="bp('done')"
    />
  </aside>
</template>

<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex';
import ProjectOneCustomizeChoice from '@/projectOne/components/rightRail/components/ProjectOneCustomizeChoice';
import ProjectOneRightRailFooter from '@/projectOne/components/rightRail/components/ProjectOneRightRailFooter';
import ProjectOneRightRailHeader from '@/projectOne/components/rightRail/components/ProjectOneRightRailHeader';

export default {
  components: {ProjectOneCustomizeChoice, ProjectOneRightRailFooter, ProjectOneRightRailHeader},

  props: {
    isSingleLevelList: {
      type: Boolean,
      default: false,
    },
    selectItemModule: {
      type: String,
      default: null,
    },
  },

  computed: {
    contentData() {
      if (this.activeRailData?.content?.groupId && Array.isArray(this.moduleGroups)) {
        return this.moduleGroups.find((group) => group.id === this.activeRailData.content.groupId);
      }

      return null;
    },

    groupId() {
      return this.contentData?.id;
    },

    topTierPackageId() {
      return this.contentData?.topTierPackageId;
    },

    rearrangedList() {
      // Find the current selection object in the selections array
      const selection = this.selections.find((selection) => selection.groupId === this.contentData?.id);

      const selectedChoiceIndex = this.contentData?.choices?.findIndex((choice) => choice.id === selection.choiceId);

      // make a deep copy of 'this.contentData', we dont want to change 'this.contentData'
      let rearrangedList = [...this.contentData?.choices];

      if (selectedChoiceIndex > -1 && rearrangedList?.length) {
        //ALERT: Magic Number. Splice gives you an array, we want the first element only.
        const selectedChoice = rearrangedList.splice(selectedChoiceIndex, 1)[0];
        rearrangedList.unshift(selectedChoice);
        return rearrangedList;
      }

      return [];
    },

    ...mapGetters('projectOne', ['activeRailData']),
    ...mapState('projectOne', ['moduleGroups', 'railDataStack', 'selections']),
  },

  methods: {
    confirmSelection() {
      this.$notify({
        type: 'success',
        message: this.bp('added'),
      });

      this.returnToInitialRailView();
    },

    displayListItem({groupId, choiceId, presentationType}) {
      if (groupId && presentationType) {
        let railConfig = {
          content: {
            groupId: groupId,
            choiceId: choiceId,
            presentationType: presentationType,
          },
        };

        this.pushToRailDataStack(railConfig);
      } else {
        console.warn('displayListItem function called without a groupId or presentationType');
      }
    },

    isSelected(id) {
      return (
        id ===
        this.selections?.find((selection) => selection.groupId === this.activeRailData?.content?.groupId)?.choiceId
      );
    },

    returnToInitialRailView() {
      while (this.railDataStack?.length > 1) {
        this.popRailDataStack();
      }
    },

    returnToPreviousRailView() {
      if (this.railDataStack?.length > 1) {
        this.popRailDataStack();
      } else {
        this.$emit('on-backpress');
      }
    },

    selectChoice(choice) {
      if (this.isSingleLevelList && this.selectItemModule) {
        this.updateSelection({
          buildId: this.$route.params.buildId,
          module: this.selectItemModule,
          selections: [{groupId: this.groupId, choiceId: choice.id, topTierPackageId: this.topTierPackageId}],
          bpData: this.bpData,
        });
      }
    },

    ...mapActions('projectOne', ['updateSelection']),
    ...mapMutations('projectOne', ['popRailDataStack', 'pushToRailDataStack']),
  },
};
</script>
